<div class="float-btn-wrapper">
  <button
    class="float-btn"
    #popover="ngbPopover"
    [ngbPopover]="actionItemsMenu"
  >
    <ng-icon
      name="hugeAdd01"
      size="35"
      [ngClass]="popover.isOpen() ? 'is-open' : 'is-close'"
    />
  </button>
  <ng-template #actionItemsMenu>
    <div class="action-item-list">
      <a
        type="button"
        class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
        (click)="createWP()"
      >
        <ng-icon class="text-80 lh-1-0" name="hugeAdd01" size="18" />
        <span class="b2 text-80 m-l-10">Create Work Package</span>
      </a>
      <!-- <a type="button" class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4">
        <ng-icon class="text-80 lh-1-0" name="hugeDownload03" size="18" />
        <span class="b2 text-80 m-l-10">Download Template for Bulk Upload</span>
      </a>
      <a href="#" class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4">
        <ng-icon class="text-80 lh-1-0" name="hugeUpload03" size="18" />
        <span class="b2 text-80 m-l-10">Bulk Upload Work Packages</span>
      </a> -->
    </div>
  </ng-template>
</div>

<!-- Withdraw Dependency Modal -->
<!-- <p-dialog
  header="Create Work Package"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="wpFormModal"
  [style]="{ width: '70rem' }"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
    <app-wp-form
      [wpList]="wpList"
      [businessThemeLists]="businessThemeLists"
      [brandLists]="brandLists"
      [teamMembersLists]="teamMembersLists"
      [userData]="userData"
      (createFormWP)="createFormWP.emit($event)"
      [isEditMode]="false"
      (wpFormModal)="closeModel($event)"
    ></app-wp-form>
  </div>
</p-dialog> -->


<p-dialog
  header="Create Work Package"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="wpFormModal"
  [style]="{ width: '70rem' }"
  (onHide)="wpFormModal = false"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
    <app-wp-form
      [wpList]="wpList"
      [businessThemeLists]="businessThemeLists"
      [brandLists]="brandLists"
      [teamMembersLists]="teamMembersLists"
      [userData]="userData"
      (createFormWP)="createFormWP.emit($event)"
      [isEditMode]="false"
      (wpFormModal)="closeModel($event)"
      [wpFormModalData]="wpFormModal"
      (wpFormModalChange)="wpFormModal = $event"
    ></app-wp-form>
  </div>
</p-dialog>

